import styled from "styled-components";

export const ContainerLayoutCamera = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    font-size: ${({$isTerminal}) => $isTerminal ? "22px" : "18px"};
  }
`;
